var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formData.id ? "编辑片花" : "新增片花",
            visible: _vm.value,
            width: "1200px",
            "append-to-body": "",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                disabled: _vm.isDisabled,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "#f6f6f6",
                    padding: "25px",
                    "border-radius": "10px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c("el-col", { attrs: { span: 11 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "100px",
                            },
                          },
                          [_vm._v("乐播片花 ID：")]
                        ),
                        _vm._v(
                          "\n            " + _vm._s(_vm.formData.id || "--")
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "对应剧片：", prop: "mediaName" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formData.mediaName || "--") +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "片花名称：", prop: "aword" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入片花名称",
                                  maxlength: 99,
                                },
                                model: {
                                  value: _vm.formData.aword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "aword", $$v)
                                  },
                                  expression: "formData.aword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "类型：", prop: "type" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择类型" },
                                  model: {
                                    value: _vm.formData.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "type", $$v)
                                    },
                                    expression: "formData.type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "其它", value: 0 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "片花/花絮", value: 1 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "预告片", value: 2 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "高能看点", value: 3 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "二次创作", value: 4 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "一般关系", value: 5 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "对应分集：",
                                prop: "episodeName",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formData.episodeName || "--") +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时长：", prop: "duration" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入时长",
                                  min: 0,
                                  type: "number",
                                },
                                on: {
                                  input: () => {
                                    if (_vm.formData.duration !== "") {
                                      const pattern = /^[1-9]\d*$/
                                      if (
                                        !pattern.test(_vm.formData.duration)
                                      ) {
                                        _vm.formData.duration = ""
                                      }
                                    }
                                  },
                                },
                                model: {
                                  value: _vm.formData.duration,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "duration", $$v)
                                  },
                                  expression: "formData.duration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "横图：",
                                prop: "horizontalImgLarge",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    width: "330px",
                                  },
                                  attrs: {
                                    action: _vm.actionUrl,
                                    "show-file-list": false,
                                    "on-success": (res) => {
                                      _vm.handleAvatarSuccess(
                                        res,
                                        "horizontalImgLarge"
                                      )
                                    },
                                    "before-upload": _vm.beforeAvatarUpload,
                                  },
                                },
                                [
                                  _vm.formData.horizontalImgLarge
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          src: _vm.formData.horizontalImgLarge,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "竖图：",
                                prop: "verticalImgLarge",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: _vm.actionUrl,
                                    "on-success": (res) => {
                                      _vm.handleAvatarSuccess(
                                        res,
                                        "verticalImgLarge"
                                      )
                                    },
                                    "before-upload": _vm.beforeAvatarUpload,
                                  },
                                },
                                [
                                  _vm.formData.verticalImgLarge
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: {
                                          src: _vm.formData.verticalImgLarge,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "视频样式：", prop: "direction" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.direction,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "direction", $$v)
                                    },
                                    expression: "formData.direction",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("横视频"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("竖视频"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: { label: "播放介质：" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "flex-start",
                                  },
                                },
                                [
                                  !_vm.isDisabled
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "mini" },
                                          on: { click: _vm.choiceMedium },
                                        },
                                        [_vm._v("选择介质")]
                                      )
                                    : _vm._e(),
                                  _vm.selectedMedium.name
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("totoLowerCase")(
                                              _vm.selectedMedium.name +
                                                "." +
                                                _vm.selectedMedium.fileFormat
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c("el-col", { attrs: { span: 11 } }),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: { label: "播放链接：", prop: "playUrl" },
                            },
                            [
                              !_vm.isDisabled
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入播放链接",
                                      maxlength: 999,
                                    },
                                    on: { blur: _vm.analysisDuration },
                                    model: {
                                      value: _vm.formData.playUrl,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "playUrl", $$v)
                                      },
                                      expression: "formData.playUrl",
                                    },
                                  })
                                : _c("div", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.formData.playUrl) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#2140ef",
                                          cursor: "pointer",
                                          padding: "0 10px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImage(
                                              _vm.formData.playUrl,
                                              "video"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("预览")]
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { margin: "0 0 0 50px", padding: "25px 25px 0" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "片花状态：", prop: "status" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "status", $$v)
                                },
                                expression: "formData.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上线"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下线"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 13 } }, [
                    _vm.isDisabled
                      ? _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#2140ef",
                                cursor: "pointer",
                                padding: "0 10px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.innerVisible = true
                                },
                              },
                            },
                            [_vm._v("三方分集信息")]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isDisabled
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.closeDialog } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.mediaEpisodeSave },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.innerVisible
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    width: "1000px",
                    title: "三方分集信息",
                    visible: _vm.innerVisible,
                    "modal-append-to-body": false,
                    "before-close": (done) => {
                      _vm.innerVisible = false
                      done()
                    },
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.innerVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "130px",
                            },
                          },
                          [_vm._v("三方分集 ID：")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formData.trailerPartnerData
                                ? _vm.formData.trailerPartnerData
                                    .partnerTrailerId || "--"
                                : "--"
                            )
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "130px",
                            },
                          },
                          [_vm._v("三方分集状态：")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formData.trailerPartnerData
                                ? { 0: "关", 1: "开" }[
                                    _vm.formData.trailerPartnerData
                                      .partnerTrailerStatus
                                  ] || "--"
                                : "--"
                            )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "130px",
                            },
                          },
                          [_vm._v("版权商分集 ID：")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formData.trailerPartnerData
                                ? _vm.formData.trailerPartnerData
                                    .copyrightMediaId || "--"
                                : "--"
                            )
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "130px",
                            },
                          },
                          [_vm._v("版权商分集编号：：")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formData.trailerPartnerData
                                ? _vm.formData.trailerPartnerData
                                    .copyrightMediaCode || "--"
                                : "--"
                            )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("Medium", { ref: "medium", on: { select: _vm.mediumSelect } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }